import { render, staticRenderFns } from "./Sabnzbd.vue?vue&type=template&id=532088d6&scoped=true"
import script from "./Sabnzbd.vue?vue&type=script&lang=js"
export * from "./Sabnzbd.vue?vue&type=script&lang=js"
import style0 from "./Sabnzbd.vue?vue&type=style&index=0&id=532088d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532088d6",
  null
  
)

export default component.exports